import { StepFunction } from "./types";

// lavatories
export const step12: StepFunction = (
  hidden_contagious,
  collective_immunity,
  ground_disrespect,
  params
) => {
  let P_total = 0,
    P_FF1 = 0,
    P_FF2 = 0,
    P_FC1 = 0,
    P_FF3_FF4 = 0,
    P_FF5 = 0,
    P_FC2 = 0;

  // probability that hands get infected from toilet / sink
  P_FF1 =
    params.hand_infection.poor_surface_cleaning *
    hidden_contagious *
    params.hand_infection.poor_hand_cleaning;

  // probability to touch face
  P_FF2 =
    (1 - collective_immunity) *
    params.mask_proba.ratio_touch_mask *
    Math.min(
      1,
      params.time.time_toilet * params.mask_proba.rate_min_touch_face
    );

  // probability of FC1
  P_FC1 = P_FF1 * P_FF2 * params.measures.fomites_factor;

  // probability that there is a contagious person nearby
  P_FF3_FF4 = hidden_contagious;

  // probability that not protected against contamination
  // note: UPDATE of mask reduction efficiency!
  P_FF5 =
    (((1 - collective_immunity) * 1 * params.mask_proba.eff_reduction1) /
      params.measures.air_con_risk_red) *
    (1 -
      (1 - params.mask_proba.rate_coughing_sneezing) **
        params.time.time_to_toilet) *
    params.boarding.pax_met_to_toilet;

  // probability of FC2
  P_FC2 = P_FF3_FF4 * P_FF5;

  // calculate total risk
  P_total = P_FC1 + P_FC2;

  return {
    P_total,
    P_FF1,
    P_FF2,
    P_FC1,
    P_FF3_FF4,
    P_FF5,
    P_FC2,
  };
};
